import { css } from "@emotion/css";
import * as RadixSelect from "@radix-ui/react-select";
import { CaretDownIcon, CaretUpIcon } from "components/icons";
import { forwardRef } from "react";
import { Text } from "../text";
import "./styles.css";

type Props = {
  options: { value: string; label: string }[];
  defaultValue?: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange: (value: string) => void;
};
export const DefaultSelect: React.FC<Props> = ({
  value,
  options,
  placeholder,
  defaultValue,
  disabled,
  onChange,
}) => {
  return (
    <RadixSelect.Root
      defaultValue={defaultValue}
      value={value}
      onValueChange={onChange}
      disabled={disabled}
    >
      <RadixSelect.Trigger
        className="SelectTrigger"
        aria-label={placeholder?.replace(" ", "")}
      >
        <RadixSelect.Value placeholder={placeholder} />
        <RadixSelect.Icon className="SelectIcon">
          <CaretDownIcon
            style={{ width: "5px", height: "5px" }}
            fill="primary"
          />
        </RadixSelect.Icon>
      </RadixSelect.Trigger>
      <RadixSelect.Portal>
        <RadixSelect.Content className="SelectContent">
          <RadixSelect.ScrollUpButton className="SelectScrollButton">
            <CaretUpIcon />
          </RadixSelect.ScrollUpButton>
          <RadixSelect.Viewport className="SelectViewport">
            {options.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                <Text.Body2XS color="primary">{option.label}</Text.Body2XS>
              </SelectItem>
            ))}
          </RadixSelect.Viewport>
          <RadixSelect.ScrollDownButton className="SelectScrollButton">
            <CaretDownIcon
              style={{ width: "5px", height: "5px" }}
              fill="primary"
            />
          </RadixSelect.ScrollDownButton>
        </RadixSelect.Content>
      </RadixSelect.Portal>
    </RadixSelect.Root>
  );
};

const SelectItem = forwardRef<HTMLDivElement, RadixSelect.SelectItemProps>(
  ({ children, className, ...props }, forwardedRef) => {
    return (
      <RadixSelect.Item
        className={css`
          padding: 4px 0px;
cursor: pointer;
        `}
        {...props}
        ref={forwardedRef}
      >
        <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
      </RadixSelect.Item>
    );
  },
);
